/** @module csi/images/LightBoxEditor **/
define([
	"dojo/_base/declare",
	"csi/_base/Deferred",
	"csi/comm/GetRequest",
	"csi/def",
	"csi/html",
	"csi/image/_base",
	"csi/locale",
	"csi/model/image",
	"csi/reflection",
	"csi/view/Widget",
	"csi/view",
	"csi/xml",
	"underscore",
	"dojo/text!./LightBoxEditor.html",

	"dijit/TitlePane",
	"./ImageCancelCrop",
	"./ImageCrop",
	"./ImageRotateLeft",
	"./ImageFlipHorizontal",
	"./ImageFlipVertical",
	"./ImageSetAction",
	"./ImageEditorReset",
	"./ImageEditorZoomin",
	"./ImageEditorZoomout",
	"./refreshWithLabel"
], function(declare, Deferred, GetRequest, def, html, csiImage, locale, {ATTR_IMAGES}, reflection, Widget, csiView, xml, _, template) {
	var dfdCropper = new Deferred();
	var STRMIME = "image/png";

	require([
		"cropper"
	], function() {
		dfdCropper.resolve();
	});

	return declare([Widget], {
		plugins: ["rotateleft", "fliphorizontal", "flipvertical", "crop", "setaction", "cancelcrop", "imagereset", "imagezoomin", "imagezoomout"/*, "brightness", "contrast", "saturation", "hue"*/],
		bImageEdited: false,
		cropperObj: null,
		editorContainerNode: null,
		jImage: null,
		templateString: template,
		cropState: false,
		resetUrl: "",

		//To Do:- this will be activated on coming release
		brightness: 100,
		contrast: 1,
		"hue-rotate": 0,
		saturate: 100,
		filterStyles: {
			brightness: "brightness(100%)",
			contrast: "contrast(1)",
			saturate: "saturate(100%)",
			"hue-rotate": "hue-rotate(0deg)"
		},

		/** @property {array} whereUsedUnlinkList -  stores the unlinked node list*/
		whereUsedUnlinkList: null,

		buildRendering: function() {
			// summary: add browser view to dialog
			this.inherited(arguments);
			this.whereUsedUnlinkList = [];

			// temporarily add class to prevent black background when loading lightbox editor
			$(this.imageEditorNode).addClass("csi-cropper-init");

			var self = this;
			var node = this.getNode();
			var rc = reflection.getClass("Image");
			var defView = def.getClassViewDef(rc, "ImageWhereUsedGallery", true);
			var countNode = html.create("span", {"class": "dijitTitlePaneTextNode"}, this.imageEditorWhereUsedBlock.titleNode, "after");
			// {string} rootUrl - url of the page node or refNode url of the image from where the light box is initiated
			var rootUrl = this.defView.getSource().imageData.containerUrl;

			this.whereUsedView = csiView.newView(defView, node, {
				onRedraw: () => {
					self.whereUsedUnlinkList = [];
					self.refreshWidget();
				},
				onViewEnd: () => {
					countNode.innerText = "(" + this.whereUsedView.queryTotalCount + ")";
					const refNodes = html.queryDom([".galleryBlock"], this.whereUsedNode);

					_.each(refNodes, (domNode) => {
						if (domNode.getAttribute("data-csi-url") == rootUrl) {
							domNode.classList.add("csi-whereused-list-root");
							const actionNode = html.queryDom([".csiAction" + html.getDataAttributeSelector(html.DATA_URL, rootUrl)], domNode)[0];
							actionNode.style.visibility = "hidden";
						} else {
							domNode.classList.add("csi-whereused-list-secondary");
							const resultNode = this.getResultNodeByDomNode(domNode);
							if (xml.nodeAttributeHasFlag(resultNode, ATTR_IMAGES, xml.NODE_FLAG_NOEDIT)) {
								// push but only if it doesn't exist already.
								this.whereUsedUnlinkList = _.union(this.whereUsedUnlinkList, [resultNode.$URL]);
							}
						}
					});
				},
				bShowMessageNode: false
			});

			this.whereUsedView.onActionUnlinkWhereUsed = function(ac) {
				var element = ac.m_element;
				if (_.contains(self.whereUsedUnlinkList, ac.m_urlNode)) {
					element.innerText = "link";
					$(element).removeClass("iconUnlink").addClass("material-icons");
					self.whereUsedUnlinkList = _.without(self.whereUsedUnlinkList, ac.m_urlNode);
					$(element.offsetParent).removeClass("csi-image-unlink");
					$(element).attr("title", locale.resource("ImageEditorUnlinkSwitch"));
				} else {
					element.innerText = "";
					self.whereUsedUnlinkList.push(ac.m_urlNode);
					$(element).removeClass("material-icons").addClass("iconUnlink");
					$(element.offsetParent).addClass("csi-image-unlink");
					$(element).attr("title", locale.resource("ImageEditorLinkSwitch"));
				}

				self._setActionButtonsDisabled();
			}

			this.whereUsedView.set("refreshTimestamp", new Date().getTime());
			this.whereUsedView.placeAt(this.whereUsedNode);
			this.whereUsedView.plugins.pop();
			this.whereUsedView.plugins.push("refreshWithLabel");
			this.whereUsedView.startup();
		},

		/**
		 * Determines if button is enabled.
		 * Save & Replace is disabled if all image nodes are unlinked
		 * @param {Widget} button
		 * @param {string} idAction
		 */
		canEnableButton: function(button, idAction) {
			const {whereUsedUnlinkList, whereUsedView} = this;
			const whereUsedLength = whereUsedView.queryTotalCount || 0;
			const unlinkedLength = whereUsedUnlinkList.length;
			return (idAction !== "Save_Replace") || (whereUsedLength === 0) || (whereUsedLength > unlinkedLength);
		},

		/**
		 * Create image from url
		 * Initialize cropper after the image finish loading
		 * @param {string} src
		 */
		createEditorImage: function(src) {
			var self = this;
			csiImage.create(this.newImageNode, src, null, "csi-editor-image").then(function() {
				_.delay(function() {
					//need a delay to wait till images are rendered so cropper can calculate the actual size of image
					self.initializeCropper();
					$(self.imageEditorLoaderNode).addClass("hide");
				}, 500);
			});
			this.resetUrl = src;
		},

		cancelCrop: function() {
			var self = this;

			if (this.cropperObj) {
				this.jImage.cropper("clear");
				this.cropState = false;
				_.delay(function() {
					//wait for cropper action to finish before removing the cropper selection
					self.jImage.cropper("setDragMode", "move");
				}, 100);
			}
		},

		/**
		 * Cropper function for initiating crop tool
		 * @param {object} ac - action controller
		 */
		crop: function(ac) {
			if (this.cropState && ac) {
				// checking cropState for toggling button
				this.cancelCrop();
			} else {
				!this.cropperObj && this.initializeCropper("crop");
				this.jImage.cropper("setDragMode", "crop");
				this.cropState = true;
				this.toggleOnCrop();
				this.jImage.cropper("crop");
			}
		},

		/**
		 * Cropper function for applying flip horizontal
		 */
		flipHorizontal: function() {
			var self = this;

			!this.cropperObj && this.initializeCropper("flipHorizontal");
			var scaleX = this.cropperObj.imageData.scaleX;

			$.when(this.cropperObj.scaleX(scaleX ? (scaleX * -1) : -1)).then(function() {
				self.cancelCrop();
			});
		},

		/**
		 * Cropper function for applying flip vertical
		 */
		flipVertical: function() {
			var self = this;

			!this.cropperObj && this.initializeCropper("flipVertical");
			var scaleY = this.cropperObj.imageData.scaleY;

			$.when(this.cropperObj.scaleY(scaleY ? (scaleY * -1) : -1)).then(function() {
				self.cancelCrop();
			});
		},

		/**
		 * Converts the image in to a file fiels and returns
		 * @return {File} this._files
		 */
		getEditedImage: function() {
			var node = this.getNode();
			var fileName = node.$Name;
			var snapshotName = fileName.split(".")[0] + ".png";

			this.cancelCrop();
			this.setCropperAction();
			this._files = [];
			this.jImage = $('.csi-editor-image');
			var src = this.jImage.attr("src");

			if (src.substring(0, 10) != "data:image") {
				src = html.convertImagetoBase64(this.jImage[0]);
			}

			var file = html.convertBase64toFile(src, snapshotName, STRMIME);
			this._files.push(file);

			return this._files;
		},

		/**
		 * Returns the node
		 */
		getNode: function() {
			return this.getViewNode();
		},

		/**
		 * Returns if image is edited
		 */
		isImageEdited: function() {
			return this.bImageEdited;
		},

		/**
		 * Initialize Cropper plugin
		 * @param {string} recall - function name
		 * @param {[object]} ac - action controller
		 */
		initializeCropper: function(recall, ac) {
			var self = this;

			if (!this.cropperObj) {
				this.jImage = $('.csi-editor-image');
				// Get the Cropper.js instance after initialized
				this.jImage.cropper({
					aspectRatio: "",
					viewMode: 0
				}).on('ready', function() {
					self.jImage.cropper("setDragMode", "move");
					self.cropperObj = self.jImage.data('cropper');
					if (self.cropperObj.imageData.naturalHeight < self.cropperObj.containerData.height) {
						self.cropperObj.zoomTo(1);
					}
					self.jImage.cropper("clear");
				});
			} else {
				this.jImage.cropper("setDragMode", "move");
				this.jImage.cropper("clear");
			}

			//add class to prevent flickering due to cropper working slow
			$(this.newImageNode).addClass("csi-cropper-init");

			_.delay(function() {
				//wait for cropper to finish initializing before clearing the default cropper
				self.jImage.cropper("clear");
				recall && self[recall](ac);
				$(self.newImageNode).removeClass("csi-cropper-init");
				$(self.imageEditorNode).removeClass("csi-cropper-init");
			}, 100);
		},

		/**
		 * Sets initial values into image attribute sliders
		 * @param {context} ctx
		 */
		initializePlugins: function(ctx) {
			//To Do:- this will be activated on coming release
			/*			var editorToolbar = ctx.view.toolbarNode;
						var self = this;
						var brightnessPlugin = editorToolbar.getPlugin("brightness");
						var contrastPlugin = editorToolbar.getPlugin("contrast");
						var huePlugin = editorToolbar.getPlugin("hue");
						var saturationPlugin = editorToolbar.getPlugin("saturation");

						brightnessPlugin.set("value", 100);
						contrastPlugin.set("value", 1);
						huePlugin.set("value", 0);
						saturationPlugin.set("value", 100);
						this.setStyle(100, "brightness", brightnessPlugin.suffix);
						this.setStyle(1, "contrast", contrastPlugin.suffix);
						this.setStyle(0, "hue-rotate", huePlugin.suffix);
						this.setStyle(100, "saturate", saturationPlugin.suffix);*/
		},

		/**
		 * disable unnecessary buttons while on crop mode
		 */
		toggleOnCrop: function() {
			if (this.cropState) {
				this.editorContainerNode.classList.add("csi-crop-on");
				this._setActionButtonsDisabled(true);
			} else {
				this.editorContainerNode.classList.remove("csi-crop-on");
			}
		},

		onViewDisable: function(disabled) {
			this.toggleOnCrop();
		},

		postCreate: function() {
			var self = this;
			this.inherited(arguments);

			var node = this.getNode();
			var large = new GetRequest("Publisher", "GetFromNode", {
				URL: node.$URL,
				Download: true,
				Attribute: reflection.ATTR_VIEWABLE
			}).toRequest();

			this.createEditorImage(large);

			$(this.newImageNode).dblclick(function() {
				self.crop();
			});
		},

		/**
		 * Resets the image to its initial state
		 */
		resetCropper: function() {
			var ctx = this.getContext();

			$(".csi-editor-image").attr("src", this.resetUrl);
			this.cropState = false;
			this.jImage && this.jImage.cropper("destroy");
			this.cropperObj = null;
			this.initializeCropper();
			this.initializePlugins(ctx);
		},

		/**
		 * Set Cropper rotate operation
		 */
		rotateLeft: function() {
			var self = this;

			!this.cropperObj && this.initializeCropper("rotateLeft");

			$.when(this.jImage.cropper("rotate", "-45")).then(function() {
				self.cancelCrop();
			});
		},

		/**
		 * Sets css style to apply image color transformations
		 * @param {number} val
		 * @param {string} property
		 * @param {string} suffix
		 */
		setStyle: function(val, property, suffix) {
			//To Do:- this will be activated on coming release
			this.filterStyles[property] = property + "(" + val + suffix + ")";
			var filterVal = _.values(this.filterStyles).join(" ");

			this[property] = val;
			$(this.newImageNode).css({"-webkit-filter": filterVal, "filter": filterVal});
		},

		/**
		 * Set Cropper transformation actions into image
		 */
		setCropperAction: function() {
			if (this.cropperObj) {
				var canvas = this.cropperObj.getCroppedCanvas();
				var imgData = canvas.toDataURL();
				this.jImage.attr("src", imgData);
				this.jImage.cropper("destroy");
				this.cropperObj = null;
				this.bImageEdited = true;
			}
			this.cropState = false;
			this.initializeCropper();
		},

		zoom: function(ac) {
			var self = this;

			if (!this.cropperObj) {
				this.initializeCropper("zoom", ac);
			} else {
				if (ac) {
					$.when(this.jImage.cropper("zoom", ac.m_action.value)).then(function() {
						self.cancelCrop();
					});
				}
			}
		},

		_onResize: function() {
			var width = $(this.ownerDocument).width();
			var height = $(this.ownerDocument).height();
			$(this.editorContainerNode).width(width).height(height);
		},

		_postView: function() {
			var ctx = this.getContext();

			this.inherited(arguments);
			html.setVisibility(this.domNode.parentNode, true);
			ctx.view.toolbarNode.enablePlugins();
			this.initializePlugins(ctx);
		}
	});
});